/* eslint-disable no-console */
/**
 * Serviço de Log Centralizado (Simplificado)
 * Gerencia a exibição de logs baseado em prioridade, similar ao backend.
 * Níveis: error (0), warn (1), info (2), debug (3)
 */

const currentLevel = process.env.VUE_APP_LOG_LEVEL || 'info';

const levels = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
    // Compatibilidade com legado
    production: 0,
    none: -1
};

const currentPriority = levels[currentLevel] !== undefined ? levels[currentLevel] : 2;

const NO_OP = () => { };

class Logger {
    constructor() {
        this.configure();
    }

    configure() {
        // Intercepta console.log/info (nível 2)
        if (currentPriority < 2) {
            console.log = NO_OP;
            console.info = NO_OP;
        }

        // Intercepta console.warn (nível 1)
        if (currentPriority < 1) {
            console.warn = NO_OP;
        }

        // Intercepta console.error (nível 0)
        if (currentPriority < 0) {
            console.error = NO_OP;
        }

        // Se estiver em debug, podemos adicionar logs extras ou manter comportamento padrão
        // console.debug já é exibido por padrão se não interceptado, 
        // mas aqui garantimos que ele só apareça se o nível for debug (3)
        if (currentPriority < 3) {
            console.debug = NO_OP;
        }

        // Log inicial apenas se info estiver habilitado
        if (currentPriority >= 2) {
            // Usando o método original do console para garantir que apareça durante a inicialização
            // (embora neste ponto console.log já possa estar modificado, mas o bind original não foi salvo de propósito para simplicidade)
            // Se console.log foi sobrescrito para NO_OP, isso não aparecerá, o que é correto.
        }
    }
}

export default new Logger();
